import Paper from '@mui/material/Paper'
import React from 'react'
import { Currency } from '../../atoms/numberFormatCustom'
import ThumbsUp from '../../images/ThumbsUp.svg'
import ThumbsDown from '../../images/ThumbsDown.svg'
import * as S from './styles'
import * as SS from '../../organisms/result/styles.js'
import { SmoothImage} from '../../atoms/SmoothImageLoad'

const whatsappLink = "https://api.whatsapp.com/send?phone=554899286828&text=Ol%C3%A1!%20Quero%20uma%20vida%20financeira%20tranquila%2C%20quero%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20Monefica!"

const PositiveDescription = ({ handleClickConversionDialogOpen }) => <Paper style={{
	padding: '20px 16px ',
	margin: 20,
	maxWidth: 900
}}>
	<SS.Row>
		<div style={{height: 40, width: 40}}>
			<SmoothImage src={ThumbsUp} height={40} width={40}/>
		</div>
		<SS.Text style={{ paddingLeft: 12, lineHeight: '1.4em'  }}>
			<strong>PARABÉNS!</strong> Você está no caminho certo, agora é se controlar para manter o plano. O Monefica te ajuda a acompanhar esse percurso.
			<br/><br/>
			<strong>Quer ficar atento as oportunidades de antecipar ou aumentar sua aposentadoria?</strong>
		</SS.Text>
	</SS.Row>
	<SS.Row>
		<S.CenteredButton onClick={() => {
			if(window.mixpanel) {
				window.mixpanel.track("Result description positive yes")
			}
			handleClickConversionDialogOpen()
		}} variant="contained" color="primary">SIM! por e-mail!</S.CenteredButton>
		<S.CenteredButton onClick={() => {
			window.open(whatsappLink, '_blank');
			if(window.mixpanel) {
				window.mixpanel.track("Result description positive yes whatapp")
			}
		}} variant="contained" color="primary">SIM! pelo whatsapp!</S.CenteredButton>
	</SS.Row>
</Paper>

const NegativeDescription = ({ handleClickConversionDialogOpen }) => <Paper style={{
	padding: '20px 16px ',
	margin: 20,
	maxWidth: 900
}}>
	<SS.Row>
		<div style={{height: 40, width: 40}}>
			<SmoothImage src={ThumbsDown} height={40} width={40}/>
		</div>
		<SS.Text style={{ paddingLeft: 12, lineHeight: '1.4em' }}>
			<strong>Opa!</strong> Seu plano tributário para 2022 pode ser melhorado com uma previdência PGBL.
			<br/><br/>
			<strong>Quer uma análise mais detalhada para melhorar esse plano?</strong>
		</SS.Text>
	</SS.Row>
	<SS.Row>
		<S.CenteredButton onClick={() => {
			if(window.mixpanel) {
				window.mixpanel.track("Result description negative yes")
			}
			handleClickConversionDialogOpen()
		}} variant="contained" color="primary">SIM!</S.CenteredButton>
	</SS.Row>
</Paper>

export function ResultSummary({initialResult}) {
	const isCompleteBetter =
		initialResult.withUserSupplementaryPension.fiscalGainFromSimplified >0

	const missingPrecidencyValue = initialResult.withSupplementaryPensionMaximum.supplementaryPensionContribution - initialResult.withUserSupplementaryPension.supplementaryPensionContribution

	return (<SS.Container>
			<Paper style={{
				padding: '20px 16px ',
				margin: 20,
				maxWidth: 900,
				width: '100%'
			}}>
			<S.UpperBox>
				<S.LabelValueBox blue>
					<label>Melhor opção de modalidade do IRPF é:</label>
					<span>{isCompleteBetter ? `Completa` : `Simplificada`}</span>
				</S.LabelValueBox>

				<S.LabelValueBox green>
					<label>Ganho em relação a {isCompleteBetter ? `simplificada` : `completa`}:</label>
					<span>{Currency(Math.abs(initialResult.withUserSupplementaryPension.fiscalGainFromSimplified))}</span>
				</S.LabelValueBox>
			</S.UpperBox>
				{ initialResult.withSupplementaryPensionMaximum.fiscalGainFromUser > 0 ?
			<S.BigBox green>
				<label>Ganho se contribuir com 12% da sua receita bruta anual em PGBL:</label>
				<span>{Currency(initialResult.withSupplementaryPensionMaximum.fiscalGainFromUser)}</span>
			</S.BigBox> : "" }
			<br/>
				{missingPrecidencyValue > 0 ?

			<S.BigBox blue>
				<label>Quanto ainda falta investir em PGBL para alcançar os 12%:</label>
				<span>{Currency(missingPrecidencyValue)}</span>
			</S.BigBox> : ""}
		</Paper>
	</SS.Container>)
}
